/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityFindingsAggAsset
 */
export interface MonitEntityFindingsAggAsset {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsAggAsset
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsAggAsset
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityFindingsAggAsset
     */
    source?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityFindingsAggAsset
     */
    shared?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityFindingsAggAsset
     */
    found?: number;
}

/**
 * Check if a given object implements the MonitEntityFindingsAggAsset interface.
 */
export function instanceOfMonitEntityFindingsAggAsset(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityFindingsAggAssetFromJSON(json: any): MonitEntityFindingsAggAsset {
    return MonitEntityFindingsAggAssetFromJSONTyped(json, false);
}

export function MonitEntityFindingsAggAssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityFindingsAggAsset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
    };
}

export function MonitEntityFindingsAggAssetToJSON(value?: MonitEntityFindingsAggAsset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'port': value.port,
        'source': value.source,
        'shared': value.shared,
        'found': value.found,
    };
}

